import { createFileRoute } from '@tanstack/react-router'
import { Wallet } from 'lucide-react'
import { BudgetsScreen } from '@/screens/billing/SCR-052-budgets'

export const Route = createFileRoute('/_app/org/budgets')({
  staticData: { screen: { id: 'SCR-052', title: 'Budgets & entitlements', group: 'Organisation', perm: 'billing.manage', order: 9, description: 'Spending limits for workspaces and keys, and what your plan includes.', icon: Wallet } },
  component: BudgetsScreen,
})
